
























































































































































































































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import { Employee as IEmployee } from "@/api/models/employee";
import { LearningRequestCreate as ILearningRequestCreate } from "@/api/models/learning-request-create";
import SearchUser from "@/components/user/SearchUser.vue";
import SearchContractor from "@/components/contractors/SearchContractor.vue";
import { ContractorNew as IContractor } from "@/api/models/contractor-new";
import api, { courseApi } from "@/getinfo-api";
import { uniqBy } from "lodash";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import {
  getCurrentUserId,
  getCurrentCompanyId,
  isRoot,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import CustomButton from "@/components/form/CustomButton.vue";
import { Course as ICourse } from "@/api/models/course";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { Video as IVideo } from "@/api/models/video";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { isAllowEditDates, studentLimitModule } from "@/plugins/modules-detect";
import CField from "@/components/form/CField.vue";
import Modal from "@/components/form/Modal.vue";
import Registration from "@/views/auth/Registration.vue";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { IUserFilter, usersFilter } from "@/utils/filter-listeners";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import { LearningRequest as ILearningRequest } from "@/api/models";

@Component({
  components: {
    DocumentNumberInput,
    CBlock,
    CSingleSelect,
    Registration,
    Modal,
    CField,
    CustomDatepicker,
    CustomButton,
    SelectEntity,
    SearchUser,
    SearchContractor
  }
})
export default class OrderForm extends Vue {
  @Prop({ default: () => [] }) addedUsers!: IUser[];
  @Prop({ default: true }) isShowCancel!: boolean;
  @Prop({ default: false }) isNewWindowOnSave?: boolean;
  @Prop() copiedRequest?: ILearningRequest;
  searchListenerByEmail!: string;
  clientType!: string;
  clientId!: string;
  resourceType!: string;
  resourceId!: string | undefined;
  price!: number;
  isSaving: boolean = false;
  users!: Array<IUser>;
  detailUsersInfo!: Array<IUser>;
  showSearchUserPlugin: boolean = true;
  selectedEntityPrice!: number | undefined;
  number!: string;
  responsibleId?: string;
  learningManagers: Array<IEmployee> = [];
  formedAt: Date = new Date();
  registeredUserEmail!: string;
  contractorList: ContractorsListClass = new ContractorsListClass({
    companyId: this.selectCompanyId
  });
  userRegisteredAtMin!: Date | undefined;
  userRegisteredAtMax!: Date | undefined;
  filteredListeners: Array<IUser> = [];
  isCanEditPrice: boolean = false;
  courseType: string = "";
  coursesList: CoursesListClass = new CoursesListClass({
    mode: "v2",
    enabled: true,
    ownerIds: undefined
  });

  data() {
    return {
      searchListenerByEmail: "",
      userRegisteredAtMin: undefined,
      userRegisteredAtMax: undefined,
      clientType: this.$store.state?.user?.user?.currentContractor?.type,
      clientId: this.$store.state?.user?.user?.currentContractor?.id,
      resourceType: undefined,
      resourceId: undefined,
      price: undefined,
      employeeList: undefined,
      users: [],
      detailUsersInfo: [],
      selectedEntityPrice: undefined,
      contractorsList: undefined,
      number: undefined,
      responsibleId: undefined,
      registeredUserEmail: undefined
    };
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isBlockAddStudent() {
    return (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <=
        this.addedUserIds.length
    );
  }

  selectResponsibleForOnlyContractor(contractor: IContractor) {
    this.responsibleId = contractor?.responsible?.id ?? undefined;
  }

  get contractor() {
    return this.$store.state.user.user.currentContractor;
  }

  get selectCompanyId() {
    return getCurrentCompanyId();
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get userId() {
    return getCurrentUserId();
  }

  get currentEmployee() {
    return this.$store.getters.userIsEmployee;
  }

  get addedUserIds() {
    return this.detailUsersInfo.map(el => el.id);
  }

  showModal() {
    this.$bvModal.show("modal-1");
  }

  get filteredUsers() {
    const params: IUserFilter = {
      email: this.searchListenerByEmail,
      fullName: this.searchListenerByEmail,
      registeredAtMin: this.userRegisteredAtMin,
      registeredAtMax: this.userRegisteredAtMax
    };
    return usersFilter(this.detailUsersInfo, params);
  }

  getOnlyCurrentContractors() {
    return this.clientType === "juridical"
      ? this.$store.state.user.user.juridicalContractor
      : this.$store.state.user.user.physicalContractor;
  }

  clearFilter() {
    this.searchListenerByEmail = "";
    this.userRegisteredAtMin = undefined;
    this.userRegisteredAtMax = undefined;
    this.filteredListeners = this.detailUsersInfo;
  }

  registerSuccess(user: IUser) {
    this.$bvModal.hide("modal-1");
    this.registeredUserEmail = user.email;
  }

  getLearningRequestManager() {
    let params: EmployeeListParams = {
      id: this.selectCompanyId,
      roles: ["learning_request_manager"],
      limit: 300
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.learningManagers = res.data.employees;
      if (this.root || this.companyOwner) {
        this.responsibleId = this.learningManagers[0].id;
      } else {
        this.responsibleId = this.currentEmployee.id;
      }
    });
  }

  cancel() {
    this.$router.push({
      name: "orders"
    });
  }

  getResourceType(type: string) {
    if (type === "course") {
      return this.courseType;
    } else {
      return this.resourceType;
    }
  }

  async createOrder() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    let users: Array<string> = [];
    this.detailUsersInfo.forEach(element => {
      users.push(element.id);
    });
    if (this.resourceId) {
      this.isSaving = true;
      let params: ILearningRequestCreate = {
        number: this.number,
        responsibleId: this.$store.state.user.user.getResponsibleId(
          this.responsibleId
        ),
        companyId: this.selectCompanyId,
        contractorId: this.$store.state.user.user.getContractorId(
          this.clientId
        ),
        resourceType: this.getResourceType(this.resourceType),
        resourceId: this.resourceId,
        price: this.$converter.setPrice(this.formattedPrice),
        formedAt: this.formedAt,
        startedAt: new Date(),
        userIds: users
      };
      api.LearningRequestApi.create(params)
        .then(async res => {
          await nextSequence();
          if (this.isNewWindowOnSave) {
            let routeData = this.$router.resolve({
              name: "orderItem",
              params: { orderId: res.data.id }
            });
            await window.open(routeData.href, "_blank");
            this.$emit("saveOrder", {
              users: this.addedUsers,
              order: res.data
            });
          } else {
            await this.$router.push({
              name: "orderItem",
              params: { orderId: res.data.id }
            });
          }
          this.isSaving = false;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store
            .dispatch("errorException", {
              vm: this,
              error: err.response
            })
            .finally(() => {
              this.isSaving = false;
            });
        });
    } else {
      this.$bvToast.toast(
        this.$tc(this.$translate.SomeRequiredFieldsAreNotFilledIn),
        {
          variant: "danger",
          title: this.$tc(this.$translate.Error)
        }
      );
    }
  }

  selectCourse(item: ICourse) {
    this.resourceId = item?.id;

    //@ts-ignore
    this.courseType = item?.version === "v2" ? "course2" : "course";
    if (this.courseType === "course2") {
      courseApi.CourseInfo.getCourseInfo(this.resourceId).then(({ data }) => {
        this.price = this.$converter.getPrice(data.price ? data.price : 0);
      });
    } else {
      this.selectedEntityPrice = this.$converter.getPrice(item.price);
    }
  }

  selectWebinar(item: IWebinar) {
    this.resourceId = item?.id;
    this.selectedEntityPrice = this.$converter.getPrice(item.price);
  }

  selectVideo(item: IVideo) {
    this.resourceId = item?.id;
    this.selectedEntityPrice = this.$converter.getPrice(item.price);
  }

  selectUser(item: IUser) {
    this.detailUsersInfo.push(item);
    this.detailUsersInfo = uniqBy(this.detailUsersInfo, "id");
  }

  deleteUsers(item: IUser) {
    this.detailUsersInfo = this.detailUsersInfo.filter((element: IUser) => {
      return element !== item;
    });
  }

  get formattedPrice() {
    if (this.selectedEntityPrice && this.resourceId && !this.isCanEditPrice) {
      this.price = +(
        this.detailUsersInfo.length * this.selectedEntityPrice
      ).toFixed(0);
    }
    return this.price;
  }

  set formattedPrice(value) {
    this.price = value;
  }

  @Watch("selectCompanyId")
  updateCompany() {
    this.learningManagers = [];
    //@ts-ignore
    this.responsibleId = undefined;
    this.getLearningRequestManager();
  }

  @Watch("clientType")
  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = this.clientType
      ? this.clientType
      : undefined;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  @Watch("addedUsers", { immediate: true })
  checkAddedUsers() {
    if (this.addedUsers.length) {
      this.addedUsers.forEach(el => {
        this.selectUser(el);
      });
    }
  }

  @Watch("copiedRequest", { immediate: true })
  setParams() {
    if (this.copiedRequest) {
      this.formedAt = this.copiedRequest?.formedAt;
      this.responsibleId = this.copiedRequest?.responsibleId;
      this.resourceType =
        this.copiedRequest?.resourceType === "course2"
          ? ""
          : this.copiedRequest?.resourceType;
      this.resourceId = this.copiedRequest?.resourceId;
      this.clientType =
        this.copiedRequest?.clientType ??
        this.copiedRequest?.contractor?.type ??
        "";
      this.clientId =
        this.copiedRequest?.clientId ??
        this.copiedRequest?.contractor?.id ??
        "";
      this.detailUsersInfo = this.copiedRequest?.users;
      this.price = this.$converter.getPrice(this.copiedRequest?.price);
    }
  }

  created() {
    this.updateCompany();
  }
}
